// src/hooks/paxTypes/useRestoreAllPaxTypes.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreAllPaxTypes as restoreAllPaxTypesAPI } from "../../api/apiPaxTypes";
import parseError from "../../utils/parseError";

const useRestoreAllPaxTypes = () => {
    const queryClient = useQueryClient();

    const { mutate: restoreAll, isPending: isRestoreAll } = useMutation({
        mutationFn: restoreAllPaxTypesAPI,
        onSuccess: (res) => {
            const message = res?.message || "Selected pax types restored successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["paxTypes"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to restore selected pax types");
        },
    });

    return { restoreAllPaxTypes: restoreAll, isRestoreAll };
};

export default useRestoreAllPaxTypes;